var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentsPaidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1356_33649",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1356_33649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4861 18.6158H12.4671V17.4425C13.1849 17.3823 13.8726 17.1247 14.5303 16.6695C15.1881 16.2143 15.5171 15.5079 15.5171 14.5503C15.5171 13.8503 15.3042 13.2534 14.8786 12.7598C14.4529 12.2663 13.6401 11.8028 12.4401 11.3695C11.3374 10.9848 10.6329 10.6547 10.3266 10.379C10.0202 10.1035 9.86706 9.7106 9.86706 9.20027C9.86706 8.68993 10.0661 8.26493 10.4641 7.92527C10.8621 7.5856 11.3912 7.41577 12.0516 7.41577C12.5592 7.41577 12.9823 7.5321 13.3208 7.76477C13.6593 7.99743 13.9336 8.2926 14.1438 8.65027L15.0131 8.30802C14.7784 7.82718 14.4345 7.4246 13.9813 7.10027C13.5281 6.77593 13.0401 6.59518 12.5171 6.55802V5.38477H11.5361V6.55802C10.6644 6.70285 10.0048 7.02785 9.55731 7.53302C9.10981 8.03818 8.88606 8.59393 8.88606 9.20027C8.88606 9.91943 9.11206 10.4951 9.56406 10.9273C10.0161 11.3593 10.7786 11.7695 11.8516 12.158C12.9272 12.5542 13.65 12.9118 14.0198 13.231C14.3896 13.5502 14.5746 13.9899 14.5746 14.5503C14.5746 15.2541 14.3179 15.7608 13.8046 16.0705C13.2911 16.38 12.7401 16.5348 12.1516 16.5348C11.5759 16.5348 11.0563 16.3672 10.5928 16.032C10.1295 15.6967 9.75931 15.2194 9.48231 14.6003L8.60156 14.981C8.88623 15.6657 9.26798 16.1993 9.74681 16.582C10.2256 16.9647 10.8054 17.2348 11.4861 17.3925V18.6158Z",
    fill: "#0E9384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5836 15.3434L17 12.7394L17.7077 12.0316L19.5836 13.9279L23.2922 10L24 10.7078L19.5836 15.3434Z",
    fill: "#0E9384"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6617 4.02742C11.2249 3.90816 9.78256 4.17942 8.48723 4.81248C7.1919 5.44555 6.09173 6.41691 5.30306 7.62382C4.51439 8.83074 4.06653 10.2284 4.00686 11.6689C3.94718 13.1094 4.2779 14.5393 4.96404 15.8073C5.65018 17.0753 6.66624 18.1343 7.90477 18.8723C9.14329 19.6104 10.5582 20 12 20V21C10.378 21 8.78621 20.5617 7.39286 19.7314C5.99952 18.9011 4.85646 17.7097 4.08455 16.2832C3.31264 14.8567 2.94058 13.2481 3.00771 11.6275C3.07485 10.0069 3.57869 8.43458 4.46594 7.0768C5.3532 5.71902 6.59089 4.62625 8.04813 3.91404C9.50538 3.20184 11.128 2.89669 12.7444 3.03084C14.3608 3.165 15.9109 3.73349 17.2308 4.67618C18.5507 5.61888 19.5913 6.90074 20.2426 8.38621L19.3268 8.78775C18.7479 7.46732 17.8229 6.32789 16.6496 5.48994C15.4764 4.65199 14.0985 4.14667 12.6617 4.02742Z",
    fill: "#0E9384"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentsPaidIcon);
export default __webpack_public_path__ + "static/media/payments-paid-icon.d7fc7e1a2638c9497c5b4382b1bcf01b.svg";
export { ForwardRef as ReactComponent };